import React from "react";
import PropTypes from "prop-types";

class StickyList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
      paddingTop: false,
      expandedItems:
        (this.props.listItems &&
          this.props.listItems.map(item => item.ariaExpanded !== false)) ||
        [],
      renderedItemCount: 6,
      totalItemCount: this.countItems()
    };

    this.mainHeaderRef = React.createRef();
    this.mainBodyRef = React.createRef();

    this._updateWidth = this._updateWidth.bind(this);
    this._scroll = this._scroll.bind(this);
    this._stickyScroll = this._stickyScroll.bind(this);
    this._resultsFillScreen = this._resultsFillScreen.bind(this);
    this._increaseRenderedItemCount = this._increaseRenderedItemCount.bind(
      this
    );
    this._toggleHeader = this._toggleHeader.bind(this);
    this._onClickHeader = this._onClickHeader.bind(this);
    this._onClickItem = this._onClickItem.bind(this);
  }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    if (!this.state.paddingTop && this.mainHeaderRef.current.offsetHeight) {
      this.setState({
        paddingTop: this.mainHeaderRef.current.offsetHeight
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // Prevent current index from being out of range.
    // This can happen if the list is filtered while you're scrolled to the bottom
    // of the list.
    if (nextProps.listItems.length !== this.props.listItems.length) {
      this.setState({
        currentIndex: 0
      });
    }

    // Make sure all items load if the total has updated
    if (nextProps.listItems) {
      this.setState({
        totalItemCount: this.countItems(),
        expandedItems:
          nextProps.listItems.map(item => item.ariaExpanded !== false) || []
      });
    }
  }

  componentDidMount() {
    this._updateWidth();
  }

  componentDidUpdate() {
    this._updateWidth();

    // https://tickets.ingramcontent.com/browse/BO-2085
    if (!this._resultsFillScreen()) {
      this._increaseRenderedItemCount();
    }
  }

  countItems(items) {
    return this.props.listItems.reduce(
      (count, item) => count + item.body.contentList.length,
      0
    );
  }

  _updateWidth() {
    // Set the header to be the width of the scroll area, not including the scrollbar
    const width = this.mainBodyRef.current.clientWidth;
    if (width && width !== this.state.width) {
      this.setState({ width });
    }
  }

  _scroll(e) {
    if (this.props.scrollEvent) {
      this.props.scrollEvent(e);
    }
    if (e) {
      if (this.lastScrollTop && e.currentTarget.scrollTop) {
        if (e.currentTarget.scrollTop > this.lastScrollTop) {
          // scrolling down
          if (this.props.scrollDown) {
            this.props.scrollDown(e.currentTarget.scrollTop);
          }
        } else if (e.currentTarget.scrollTop < this.lastScrollTop) {
          // scrolling up
          if (this.props.scrollUp) {
            this.props.scrollUp(e.currentTarget.scrollTop);
          }
        }
      }
      this.lastScrollTop = e.currentTarget.scrollTop;
    }
  }

  _stickyScroll(e) {
    this._scroll(e);
    const children = $(e.currentTarget).children();
    for (var i = 0; i < children.length; i++) {
      const $child = $(children[i]);
      const childTop = $child.position().top;
      if (-childTop < $child.height()) {
        if (childTop < 0) {
          const header = $child.find(".stickyheader");
          const top = Math.max(
            0,
            Math.min(-childTop, $child.height() - header.height())
          );
          const ntop = 0;
          // const ntop = childTop + $child.height()-this.mainHeaderRef.current.offsetHeight;
          if (ntop < 0) {
            this.setState({ ntop: ntop });
          } else if (this.state.ntop < 0) {
            this.setState({ ntop: 0 });
          }
          if (i === children.length - 1) {
            // never going to get past the last child, so it should use it's own header!
            if (this.state.currentIndex !== i) {
              this.setState({
                currentIndex: i,
                ntop: 0
              });
            }
            break;
          }
        } else {
          const setTo = Math.max(0, i - 1);
          if (this.state.currentIndex !== setTo) {
            this.setState({
              currentIndex: setTo,
              ntop: 0
            });
          }
          break;
        }
      }
    }
    Fraction.Helpers.throttle(
      () => {
        if (!this._resultsFillScreen()) {
          this._increaseRenderedItemCount();
        }
      },
      15,
      300,
      "scroll-sticky-list"
    );
  }

  _resultsFillScreen() {
    const stickyListBody = $(this.mainBodyRef.current).get(0);
    const scrollTop = $(stickyListBody).scrollTop();
    const relativeHeight =
      stickyListBody.scrollHeight - stickyListBody.offsetHeight - 30;
    return relativeHeight >= scrollTop;
  }

  _increaseRenderedItemCount() {
    let { renderedItemCount, totalItemCount } = this.state;
    if (renderedItemCount < totalItemCount) {
      renderedItemCount = Math.min(renderedItemCount + 6, totalItemCount);
    }

    // Make sure not to set the state if it's already at the max item count,
    // otherwise we'll end up in an infinite loop since this function is called
    // after rendering.
    if (renderedItemCount !== this.state.renderedItemCount) {
      this.setState({
        renderedItemCount: renderedItemCount
      });
    }
  }

  _toggleHeader(i, mainHeaderToggled) {
    if (mainHeaderToggled) {
      const $mainBody = $(this.mainBodyRef.current);
      $mainBody.scrollTop($mainBody.find(".current").get(0).offsetTop + 1);
    }

    this.setState(state => {
      const expandedItems = state.expandedItems;
      expandedItems[i] = !expandedItems[i];
      return { expandedItems };
    });
  }

  _onClickHeader(e) {
    if (!this.state.toggleDisabled) {
      this._toggleHeader(this.state.currentIndex, true);
    }

    const item = this.props.listItems[this.state.currentIndex];
    if (item.onHeaderClick) {
      item.onHeaderClick(e);
    }
  }

  _onClickItem(item, i) {
    if (!this.props.toggleDisabled) {
      this._toggleHeader(i);
    }
    if (item.onHeaderClick) {
      item.onHeaderClick();
    }
  }

  renderHeader() {
    const { currentIndex, width, ntop } = this.state;
    const { listItems } = this.props;
    const CurrentHeader = listItems.length && listItems[currentIndex].header;
    /* This should probably/maybe use a heading tag, but I'm not sure what level it would be */
    return (
      <button
        ref={this.mainHeaderRef}
        tabIndex={-1}
        aria-hidden={true}
        className="sticky-list-header"
        onClick={this._onClickHeader}
        style={{ top: ntop, width }}
        key="main-sticky-list-header"
      >
        {React.cloneElement(CurrentHeader, {
          expanded: this.state.expandedItems[currentIndex]
        })}
      </button>
    );
  }

  renderItems(currentHeader) {
    const { currentIndex, expandedItems, renderedItemCount } = this.state;
    let bodyItemCount = 0;
    return this.props.listItems.map((item, i) => {
      const expanded = expandedItems[i];
      const ariaExpanded =
        typeof item.ariaExpanded === "undefined" ? expanded : item.ariaExpanded;
      if (bodyItemCount > renderedItemCount) {
        return;
      }
      return (
        <li
          key={`sticky-list-item-${i}`}
          className={`sticky-list-item ${currentIndex === i ? "current" : ""}`}
        >
          <button
            key={"sticky-list-item-header-" + i}
            className="sticky-list-item-header"
            tabIndex={0}
            aria-expanded={
              typeof item.ariaExpanded === "undefined"
                ? ariaExpanded
                : item.ariaExpanded
            }
            onClick={() => this._onClickItem(item, i)}
          >
            {React.cloneElement(item.header, { expanded: ariaExpanded })}
          </button>
          {ariaExpanded && (
            <div
              className="sticky-list-item-body"
              key={"sticky-list-item-body-" + i}
            >
              <ol
                className={item.body.className}
                key={"sticky-list-item-body-list-" + i}
              >
                {item.body.contentList.map(bodyItem => {
                  if (this.state.bodyItemCount > this.props.renderedItemCount) {
                    return;
                  }
                  bodyItemCount++;
                  return bodyItem;
                })}
              </ol>
            </div>
          )}
        </li>
      );
    });
  }

  render() {
    const { currentIndex } = this.state;
    const { listItems } = this.props;
    if (listItems.length) {
      const currentHeader = listItems[currentIndex].header;
      return (
        <div className="sticky-list" key={`sticky-list-${currentHeader}`}>
          {this.renderHeader(currentHeader)}

          <ol
            ref={this.mainBodyRef}
            className="sticky-list-body"
            id={this.props.id || ""}
            onScroll={this._stickyScroll}
            key={"sticky-list-body-" + listItems.length}
            tabIndex={-1}
          >
            {this.renderItems()}
          </ol>
        </div>
      );
    }
  }
}

StickyList.propTypes = {
  id: PropTypes.string,
  toggleDisabled: PropTypes.bool,
  scrollEvent: PropTypes.func,
  scrollDown: PropTypes.func,
  scrollUp: PropTypes.func,
  listItems: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.element,
      onHeaderClick: PropTypes.func,
      body: PropTypes.shape({
        className: PropTypes.string,
        contentList: PropTypes.arrayOf(PropTypes.element)
      })
    })
  )
};

StickyList.defaultProps = {
  id: "",
  listItems: [],
  toggleDisabled: false
};

export { StickyList };
